import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { currentPageReportTemplate, onPageChange, paginatorTemplate } from "../../../utilities/TableUtil";
import { normalColumn, actionEditColumn } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

export default function P412List_B({ dataTable, setAction, setDis }) {
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    // const [globalFilter, setGlobalFilter] = useState(null);
    const actionBodyNew = () => setAction({ target: "414", action: "NEW", data: null });
    const actionBodyEdit = (rowData = null) => setAction({ target: "414", action: "EDIT", data: rowData });

    const headerLabel = <span className="hidden-responsive">เพิ่มคณะกรรมการตรวจรับพัสดุ</span>;

    const header = (
        <div className="table-header">
            <Button className="p-button p-button-success btn-hidden-responsive " icon="pi pi-plus" label={headerLabel} onClick={() => actionBodyNew()}  disabled={setDis === "NEW" ? true : false}  />
        </div>
    );

    return (
        <div className="datatable-responsive-modify">
            {/* <div className="card"> */}
                <DataTable
                    // ref={(el) => dt = el}
                    value={dataTable}
                    dataKey="id"
                    paginator
                    header={header}
                    first={pageConf.first}
                    rows={pageConf.rows}
                    onPage={(e) => onPageChange(e, setPageConf)}
                    rowsPerPageOptions={[5, 10, 25]}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    // globalFilter={globalFilter}
                    emptyMessage="ไม่พบข้อมูล"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    selectionMode="single"
                >
                    <Column field="committeeName" header="ชื่อ–นามสกุล" sortable body={(e) => normalColumn(e, "committeeName", "ชื่อ–นามสกุล")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="committeeEmployeeId" header="รหัสพนักงาน" body={(e) => normalColumn(e, "committeeEmployeeId", "รหัสพนักงาน")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="committeeTitleDesc" header="ตำแหน่งในโครงการ" body={(e) => normalColumn(e, "committeeTitleDesc", "ตำแหน่งในโครงการ")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="committeeUpdateUserName" header="ผู้แก้ไข" body={(e) => normalColumn(e, "committeeUpdateUserName", "ผู้แก้ไข")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="committeeUpdateDt" header="วันที่-เวลาแก้ไข" body={(e) => normalColumn(e, "committeeUpdateDt", "วันที่-เวลาแก้ไข")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column header="แก้ไข" field="photoPath" body={(e) => actionEditColumn(e, actionBodyEdit)} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER}></Column>
                </DataTable>
            {/* </div> */}
        </div>
    );
}
